import { Component, Input, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { FilesService } from '../../../core/services/files.service';
import { MessageAttachment } from '../../../core/services/communication.service';
import { FileImagePreviewComponent } from '../file-image-preview/file-image-preview.component';
@Component({
  selector: 'app-chat-attachment',
  imports: [FileImagePreviewComponent],
  template: `
    <div class="attachment-card border rounded-3 p-2 bg-white">
      <app-file-image-preview [file]="attachment" [showThumbnail]="true" />
      <button type="button" class="btn btn-sm primary-color text-start text-break d-flex align-items-center gap-2" [disabled]="downloading" (click)="download()" [attr.aria-label]="'Преземи ' + attachment.fileName">
        <span aria-hidden="true">↓</span><span>{{attachment.fileName}}<span class="d-block small text-muted">{{(attachment.sizeInBytes / 1048576).toFixed(2)}} MB</span></span>
      </button>
      @if (downloadError) { <p class="text-danger small mb-0" role="alert">Датотеката не може да се преземе.</p> }
    </div>
  `,
  styles: ':host{display:block;min-width:0}'
})
export class ChatAttachmentComponent implements OnDestroy {
  @Input({ required: true })
  attachment!: MessageAttachment;
  downloading = false;
  downloadError = false;
  private subs = new Subscription();
  constructor(private files: FilesService) { }
  download(): void {
    if (this.downloading)
      return;
    this.downloading = true;
    this.downloadError = false;
    this.subs.add(this.files.requestDownloadTicket(this.attachment.id).subscribe({
      next: result => { this.files.startBrowserDownload(result.ticket); this.downloading = false; },
      error: () => { this.downloadError = true; this.downloading = false; }
    }));
  }
  ngOnDestroy(): void { this.subs.unsubscribe(); }
}
